import { actionsRequest, handleRequestError } from '@/api/utils'
import { Action, ACTION_TYPE } from '@/types/action'
import { ERROR_CODE } from '@/types/error'

export const setReminder = async <
  A extends ACTION_TYPE.SET_REMINDER_WEEKLY | ACTION_TYPE.SET_REMINDER_PHARMACY | ACTION_TYPE.SET_REMINDER_PHYSICIAN,
  T extends Action<A>
>({
  uniqueId,
  reminder,
  action
}: Omit<T['payload'], 'timezoneOffset'> & {
  action: A
}): Promise<T['response']> => {
  try {
    const body = await actionsRequest<T>({
      payload: {
        uniqueId,
        reminder,
        timezoneOffset: new Date().getTimezoneOffset()
      },
      type: action
    })

    if (!body?.data) throw new Error(ERROR_CODE.NO_DATA)

    const { reminder: settedReminder } = body.data

    return {
      reminder: settedReminder
    }
  } catch (err) {
    handleRequestError(err, action)
    throw err
  }
}
